module.exports = __webpack_public_path__ + "img/dog_web.314b767c.png";